export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_14-b03a86f5ef04ebd7e82d6e34e5c4360c.jpg";